import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/site";

const CREATE_FIELDS = {
  "/Public/Site/Create": {
    fields: ["siteId", "title"],
  },
};

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({ history }) => {
  const { base } = useSectionContext();
  const initial = {
    siteId: "",
    title: "",
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/Site/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update({})}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { input } });
      }}
      onCompleted={(data) => {
        // Straight into the new site's pages, not back to the list and not
        // onto the site's own view screen: a site is created empty and the only
        // reason to make one is to put pages in it. Its view is a click away on
        // the Site tab, where its Edit and Remove live.
        const created = data && data.viewer.account.sites.create;

        history.replace(created ? `${base}/${created.siteId}/page` : base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: CREATE_FIELDS,
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
